module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/zh-hans_6-17bf054f01c7b2eb3947961ecac9fe81.jpg";